module.exports = __webpack_public_path__ + "static/media/DITTO-BNB.19314e1f.svg";